import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router/immutable';
import { Map } from 'immutable';
import configureStore from './store/store';
import history from './history/history';
import './styles/styles.css';
import './styles/fonts.css';
import 'antd/dist/antd.css';
import App from './App';
import ErrorBoundary from './ErrorBoundary';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const preloadedState = Map();
const store = configureStore(preloadedState);


if(!process.env.REACT_APP_GEMINI_USER) {

  /**
 * Auth0 object initialization
 */

  const { Auth0Client } = require('@auth0/auth0-spa-js');
 
  window.auth0 = new Auth0Client({
    domain: process.env.REACT_APP_AUTH0_DOMAIN,
    client_id: process.env.REACT_APP_AUTH0_CLIENTID,
    audience: process.env.REACT_APP_AUTH0_AUDIENCE,
    cacheLocation: "localstorage",
    useRefreshTokens: true
  });

} else {
  window.auth0 = undefined;
}


ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root'),
);
